/**
 * Tipos de cuenta CC/CA requeridos por el backend para monitoreo Link (POST /dolares)
 * cuando está activa la variable backend.audit.fraud.newTransactions.functionalities.
 *
 * @param {object|null|undefined} account Cuenta del reducer `accounts`
 * @returns {"CC"|"CA"|""}
 */
export const getTipoCuentaCmfLink = (account) => {
    if (!account || typeof account !== "object") {
        return "";
    }
    const candidates = [account.productType, account.favoriteProductType];
    for (let i = 0; i < candidates.length; i += 1) {
        const raw = candidates[i];
        if (raw != null) {
            const pt = String(raw)
                .trim()
                .toUpperCase();
            if (pt === "CC" || pt === "CA") {
                return pt;
            }
        }
    }
    return "";
};

/**
 * @param {string|number|null|undefined} cuentaRef Número de cuenta o idProduct seleccionado
 * @param {string|null|undefined} previewTipo Valor guardado desde el preview (si existe)
 * @param {Array<object>} accounts Lista de cuentas del usuario
 * @returns {"CC"|"CA"|""}
 */
export const resolveTipoCuentaFromAccounts = (cuentaRef, previewTipo, accounts) => {
    const fromPreview = previewTipo != null && String(previewTipo).trim() !== "";
    if (fromPreview) {
        const t = String(previewTipo)
            .trim()
            .toUpperCase();
        return t === "CC" || t === "CA" ? t : "";
    }
    if (cuentaRef == null || cuentaRef === "") {
        return "";
    }
    const list = accounts || [];
    const acc = list.find(
        (a) =>
            String(a.number) === String(cuentaRef) ||
            (a.idProduct != null && String(a.idProduct) === String(cuentaRef)),
    );
    return getTipoCuentaCmfLink(acc);
};
